import { Injectable, EventEmitter /* HostListener, OnInit */ } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class RotationService {
  // Commenting stuff related to the rotation handler
  // in case we need it in the future.

  // showRotationScreenUpdated: EventEmitter<boolean> = new EventEmitter();
  isLandscapeUpdated: EventEmitter<boolean> = new EventEmitter();
  public vh: number = 0;

  public showRotationScreen: boolean = false;
  public isLandscape: boolean = false;

  addResizeEventListener() {
    window.visualViewport.addEventListener('resize', this.handleResize.bind(this));
    this.handleResize();
  }

  handleResize() {
    this.setCustomCSSvhProperty();
    const windowWidth = Math.ceil(window.visualViewport.width * window.visualViewport.scale);
    const windowHeight = Math.ceil(window.visualViewport.height * window.visualViewport.scale);
    const isLandscape = windowWidth > windowHeight;
    if (isLandscape !== this.isLandscape) {
      this.isLandscape = isLandscape;
      this.isLandscapeUpdated.emit(this.isLandscape);
    }
  }

  setCustomCSSvhProperty() {
    const windowHeight = Math.ceil(window.visualViewport.height * window.visualViewport.scale);
    this.vh = windowHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${this.vh}px`);
  }

  // setShowRotationScreen(visible: boolean) {
  //   this.showRotationScreen = visible;
  //   this.showRotationScreenUpdated.emit(this.showRotationScreen);
  // }

  // getShowRotationScreen() {
  //   return this.showRotationScreen;
  // }
}
